module.exports = __webpack_public_path__ + "677433a0892aaed7b7d2628c313c9775.svg";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/content/fonts/BebasNeue-Regular.svg
// module id = 365
// module chunks = 1